import {EventDB_Error, EventInfoDB, EventFullInfo, GetCalendarEventsResponse, GetSpecificEventResponse} from '../models/event';
import {getUserDetails} from '../models/user/userInfo';
import moment from 'moment';


function isGetCalendarEventsResponse(resp: GetCalendarEventsResponse | EventDB_Error): resp is GetCalendarEventsResponse
{
    return(resp as GetCalendarEventsResponse).result === 'success';
}





function isGetSpecificEventResponse(resp: GetSpecificEventResponse | EventDB_Error): resp is GetSpecificEventResponse
{
    return(resp as GetSpecificEventResponse).result === 'success';
}





export const getCalendarEvents = async (from: Date, to: Date): Promise<EventFullInfo[] | undefined> =>
{
    console.log("Getting all events");
    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==' }
    }

    const propRequestBody = {
        "propagation_range" : moment(to).format('YYYY-MM-DD').toString(), 
        "locale" : "America/New_York" 
    }

    const propRequestOptions = {
        method: 'POST',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==' , 'Content-Type': 'application/json' },
        body: JSON.stringify(propRequestBody)
    }

    let queryParams = from === undefined ? "" : "from=" + encodeURIComponent(from.toISOString()) + '&';
    queryParams += to === undefined ? "" : "to=" + encodeURIComponent(to.toISOString());
    console.log("queryParams: " + queryParams);

    const propresult = await fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event2/series/prop/all', propRequestOptions)

    console.log(propresult.status)


    return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/cal/events' + (queryParams && "?" + queryParams), requestOptions)
        .then((response) => {
            if (!response.ok) {
                console.log('Fetch Error in getCalendarEvents')
                console.log(`HTTP Response Code: ${response.status}`)
                throw ('Bad Fetch');
            } else {
                return response;
            }
        })
        .then(res => res.json())
        .then((res: EventDB_Error | GetCalendarEventsResponse) => {
            if (isGetCalendarEventsResponse(res)) {
                return res.data;
            } else {
                console.log(`Backend Error in getCalendarEvents Reason ${res.reason}`)
                res.exception && console.log(`Exception ${res.exception}`)
                res.message && console.log(`Message ${res.message}`)
                return undefined;
            }
        })
        .then((res) => {
            if (!res) {
                return;
            }
            return Promise.all(res.map(makeEventInfo));
        })
        .catch((reason) => {
            console.log('Fetch Exception in getCalendarEvents')
            console.log(`Reason: ${reason}`)
            return undefined;
        })
}





export const getSpecificEvent = (eventId: number): Promise<EventFullInfo | undefined> =>
{
    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==' }
    }

    return fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/event?id=${encodeURIComponent(eventId)}`, requestOptions)
        .then((response) => {
            if (!response.ok) {
                console.log('Fetch Error in getSpecificEvent')
                console.log(`HTTP Response Code: ${response.status}`)
                throw ('Bad Fetch');
            } else {
                return response;
            }
        })
        .then(res => res.json())
        .then((res: EventDB_Error | GetSpecificEventResponse) => {
            if (isGetSpecificEventResponse(res)) {
                return res.data;
            } else {
                console.log(`Backend Error in getSpecificEvent Reason ${res.reason}`)
                res.exception && console.log(`Exception ${res.exception}`)
                res.message && console.log(`Message ${res.message}`)
                return undefined;
            }
        })
        .then( async (res) => {
            if (!res) {
                return;
            }
            const evtInfo = await makeEventInfo(res);
            return evtInfo;
        })
        .catch((reason) => {
            console.log('Fetch Exception in getSpecificEvent')
            console.log(`Reason: ${reason}`)
            return undefined;
        })
}





export async function makeEventInfo(res: EventInfoDB): Promise<EventFullInfo> {
    const default_values : {[key: string]: number} = {
        venue: 1,
        slots: 20,
        lowest_table_number: 1,
        highest_table_number: 4,
        eType: 2
    }

    for (let k of Object.keys(default_values)) {
        if (!res.hasOwnProperty(k))
            console.warn(`Event id ${res.id} missing ${k}. Using default value ${default_values[k]}.`) 
    }

    const startTimegmt = moment.tz(res.start_datetime, "GMT");
    const endTimegmt = moment.tz(res.end_datetime, "GMT");

    const eventInfo: EventFullInfo = {
        id: res.id,
        name: res.name,
        venue: (res.venue !== null) ? res.venue : default_values.venue,
        start_DateTime: startTimegmt.clone().tz('America/New_York'),
        end_DateTime: endTimegmt.clone().tz('America/New_York'),
        info: (res.info !== null) ? res.info : "",
        website_URL: (res.website_url !== null) ? res.website_url : "",
        slots: (res.slots !== null) ? res.slots : default_values.slots,
        lowest_Table_Number: (res.lowest_table_number !== null) ? res.lowest_table_number : default_values.lowest_table_number,
        highest_Table_Number: (res.highest_table_number !== null) ? res.highest_table_number : default_values.highest_table_number,
        owner: (res.owner !== null && res.owner !== undefined) ? await getUserDetails(res.owner).then(usr => (usr === undefined ? "" : usr.user_name)) : "",
        ...(res.series_id) && {seriesId: res.series_id},
        series_ID: res.series_id ? res.series_id : undefined,
        main_Map_Image: (res.main_map_image !== null) ? res.main_map_image : "",
        venue_Series_Aligned: (res.venue_series_aligned !== null) ? res.venue_series_aligned : false,
        info_Series_Aligned: (res.info_series_aligned !== null) ? res.info_series_aligned : false,
        start_Time_Series_Aligned: (res.start_time_series_aligned !== null) ? res.start_time_series_aligned : false,
        end_Time_Series_Aligned: (res.end_time_series_aligned !== null) ? res.end_time_series_aligned : false,
        website_URL_Series_Aligned: (res.website_url_series_aligned !== null) ? res.website_url_series_aligned : false,
        slots_Series_Aligned: (res.slots_series_aligned !== null) ? res.slots_series_aligned : false,
        lowest_Table_Number_Series_Aligned: (res.lowest_table_number_series_aligned !== null) ? res.lowest_table_number_series_aligned : false,
        highest_Table_Number_Series_Aligned: (res.highest_table_number_series_aligned !== null) ? res.highest_table_number_series_aligned : false,
        main_Map_Image_Series_Aligned: (res.main_map_image_series_aligned !== null) ? res.main_map_image_series_aligned : false,
        occurence_Number: res.occurence_number,
        travel_Info: (res.travel_info !== null) ? res.travel_info : "",
        parking_Info: (res.parking_info !== null) ? res.parking_info : "",
        lodging_Info: (res.lodging_info !== null) ? res.lodging_info : "",
        food_Info: (res.food_info !== null) ? res.food_info : "",
        beverages_Info: (res.beverages_info !== null) ? res.beverages_info : "",
        private: (res.private !== null) ? res.private : false,
        eType: (res.eType !== null) ? res.eType : default_values.eType,
        is_Cancelled: (res.is_Cancelled !== null) ? res.is_Cancelled : false,
        registration_Info: (res.registration_info !== null) ? res.registration_info : "",
        session_lock: (res.session_lock !== null) ? res.session_lock: false
    }

    return eventInfo;
}